import { element } from 'prop-types';
import { data } from './content'
import { LANG } from './LangConfig'

const form = data[LANG].form;
const formLang = LANG;


export const scrollToAnchor = (id) => {
    const elmnt = document.getElementById(id);
    elmnt.scrollIntoView({ behavior: "smooth" });

    // const yOffset = -10; 
    // const element = document.getElementById(id);
    // const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    // window.scrollTo({top: y, behavior: 'smooth'});
};

export const pageDomain = process.env.REACT_APP_DOMAIN ? process.env.REACT_APP_DOMAIN : window.location.host

export const sideMenu = new window.SideForm.PromoSpinAndWin({
    documentID: 'app-side',
    lang: formLang,
    countryCode: 'au',
    setting: {
        title: form.get_started,
        subtitle: form.subtitle,
        bottomText: form.bottom_text
    },
    pageDomain: () => (pageDomain),
    callback: (token, cloudhubOption) => {
        localStorage.setItem("lottery_token", token)
        localStorage.setItem("url", cloudhubOption)

        window.location.reload()
        document.getElementById('spin-wheel').scrollIntoView()
    }
})
